<template>
  <transition name="fade">
    <TheModal v-if="isShow" id="compare-modal" @close="toggle">
      <template slot="header">
        <i class="far fa-fw fa-bring-forward"></i>
        Compare
      </template>

      <div v-if="compareItems.length" class="compare-items">
        <CardProduct
          v-for="product in compareItems"
          :key="product.id"
          :simple="true"
          :data="product" />
      </div>

      <div v-else class="compare-empty">
        <i class="far fa-fw fa-archive"></i>
        <div>Compare item empty</div>
      </div>

      <template slot="footer">
        <div>
          <button
            type="button"
            class="button-prev btn btn-primary"
            :disabled="!compareItems.length"
            @click="emptyCompare">
            <i class="far fa-fw fa-trash-alt"></i>
            Empty
          </button>
        </div>

        <div>
          <button
            type="button"
            class="btn btn-outline-primary"
            @click="toggle">
            Close
          </button>
          <button
            type="button"
            class="button-next btn btn-primary"
            :disabled="compareItems.length < 2"
            @click="compare">
            Compare
          </button>
        </div>
      </template>
    </TheModal>
  </transition>
</template>

<script>
import bus from '@/plugins/bus';

export default {
  name: 'TheCompareModal',

  data() {
    return {
      isShow: false,
    };
  },

  computed: {
    compareItems() {
      return this.$store.state.compare;
    },
  },

  mounted() {
    bus.$on('toggle-compare-modal', this.toggle);
  },

  beforeDestroy() {
    bus.$off('toggle-compare-modal', this.toggle);
  },

  methods: {
    toggle() {
      this.isShow = !this.isShow;
    },

    emptyCompare() {
      this.$store.commit('CLEAR_COMPARE_ITEM', true);
      this.toggle();
    },

    generateQuery() {
      const queries = {};

      this.compareItems.forEach((item, index) => {
        queries[`product${index + 1}`] = item.slug;
      });

      return queries;
    },

    compare() {
      const queries = this.generateQuery();
      this.$store.commit('CLEAR_COMPARE_ITEM');
      this.toggle();
      this.$router.push({ path: '/compare', query: queries });
    },
  },
};
</script>

<style lang="scss">
  #compare-modal {
    .modal-footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 1rem;

      .btn {
        min-width: 6rem;

        + .btn {
          margin-left: 0.5rem;
        }
      }
    }

    .compare-items {
      display: flex;
      justify-content: flex-start;
      padding: 1rem 0;

      .card {
        width: calc(33.333% - 0.5rem);
      }
    }

    .compare-empty {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      padding: 4rem 0;
      text-align: center;

      > * {
        width: 100%;
      }

      svg {
        margin-bottom: 1rem;
        height: 4rem;
        width: 4rem;
        color: $grey;
      }
    }
  }
</style>
